import React from 'react';
import styles from './MapListingCard.module.scss';
import { ButtonLinkPill, ButtonLinkStandard } from '@src/components/ButtonLink';
import { MapListingCardType } from '@src/types/map';
import MediaImage from '@src/components/MediaImage';
import LinkWrapper from '@src/components/LinkWrapper';
import BoxIcon from '@src/elements/BoxIcon';

const MapListingCard = ({
  title,
  image,
  forSaleSlug,
  communitySlug,
  suburb,
  subtext,
  state
}: MapListingCardType) => {
  return (
    <div data-testid="mapListingCard" className={styles.mapCardContainer}>
      <LinkWrapper href={communitySlug} aria-label={`Explore ${title}`}>
        <div className={styles.mapCardHero}>
          {image && <MediaImage {...image} thumb />}
        </div>
      </LinkWrapper>
      <h3 className={styles.mapCardTitle}>{title}</h3>
      <div className={styles.mapCardContent}>
        <div className={styles.mapCardLocation}>
          {suburb} {state} <BoxIcon name="map" size="xs" />
        </div>
        <p className={styles.mapCardSubtext}>{subtext}</p>
      </div>
      <div className={styles.mapCardCta}>
        <ButtonLinkStandard
          href={communitySlug}
          size="md"
          boxIcon="right-arrow-alt"
        >
          Explore
        </ButtonLinkStandard>
        {forSaleSlug && (
          <ButtonLinkPill
            href={forSaleSlug}
            boxIcon="right-arrow-alt"
            className={styles.forSalePill}
          >
            For Sale
          </ButtonLinkPill>
        )}
      </div>
    </div>
  );
};

export default MapListingCard;
